import React, {useState} from 'react';
import {ChevronDown} from 'lucide-react';
import './ExpandableSection.scss';

// Collapsible detail card. Children mount on the first expand (so their API calls run once)
// and are only hidden on collapse, keeping their data and pagination.
const ExpandableSection = ({title, icon = null, index = null, className = '', children}) => {
    const [expanded, setExpanded] = useState(false);
    const [opened, setOpened] = useState(false);

    const toggle = () => {
        setOpened(true);
        setExpanded(prev => !prev);
    };

    return (
        <section className={`expandable-section${expanded ? ' expandable-section--expanded' : ''} ${className}`.trim()}>
            <div className="expandable-section__header" onClick={toggle}>
                {index && <span className="expandable-section__index">{index}</span>}
                <div className="expandable-section__heading">
                    {icon && <span className="expandable-section__icon">{icon}</span>}
                    <h2 className="expandable-section__title">{title}</h2>
                </div>
                <button
                    type="button"
                    className="expandable-section__chevron"
                    aria-expanded={expanded}
                    aria-label={title}
                >
                    <ChevronDown size={18}/>
                </button>
            </div>
            {opened && (
                <div className="expandable-section__body" hidden={!expanded}>
                    {children}
                </div>
            )}
        </section>
    );
};

export default ExpandableSection;
